




































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Popup, Dialog, Picker, Toast, Popover } from 'vant';
import WorksList from '../components/WoksList.vue';
import { isWeiXin, WechatLogin } from '@/common/ts/common';
import moment from 'moment';
import PicShow from '../components/PicShow.vue';
import { getList } from '../api';
import NewsItem from '../components/NewsItem.vue';
import {
  getRules,
  ifRegister,
  userInfo,
  register,
  convert,
  balance,
  cardMachine,
  machineBalance,
  homeInfo,
  titleList,
} from '../api';
Vue.use(Popup)
  .use(Dialog)
  .use(Picker)
  .use(Toast)
  .use(Popover);
@Component({
  components: {
    WorksList,
    PicShow,
    NewsItem,
  },
})
export default class Home extends Vue {
  downLoadUrl =
    'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
  ruleShow = false;
  userCenterShow = false;
  confirmConvertVar = false;
  addressVar = false; // 地址选择变量
  successConvertVar = false; // 兑换成功显示
  tabActiveIndex = 0;
  // noRice = true;
  selectAddress = ''; // 选中的地址
  bindPhoneVar = false;
  phone = '';
  userInfo: any = {}; // 用户信息
  BIND_PHONE_STATE = false;
  menu: boolean = false;
  actions: any = [
    { text: '公益广告', url: 'https://t.cqcb.com/18x5n' },
    {
      text: '有声作文',
      url:
        'https://activity.cqcb.com/shangyou_activity/2020h2/20210121GPYJ/recruit',
    },
    {
      text: '惜粮视频',
      url:
        'https://activity.cqcb.com/shangyou_activity/2020h2/20201130DSPDS/home',
    },
    {
      text: '响应倡议',
      url: 'https://www.cqcb.com/h5/chidewenming/index.html',
    },
  ];
  tabs = [
    {
      icon: require('../assets/2025img/lightdisk.png'),
      path: './apply',
    },
    {
      icon: require('../assets/2025img/myrice.png'),
      path: './recruit',
    },
  ];
  // columns = [];
  userTab = [
    {
      text: '我的徽章',
      index: 0,
    },
    {
      text: '我的卡券',
      index: 1,
    },
  ];
  successConvert: any = {};
  machineList = [];
  machineB = 0;
  homeInfo: any = {};
  rules: any = {};
  numOfCoffee = '';
  newsList: any = [];
  get columns() {
    return this.machineList.map((item: any) => item.position);
  }
  get noRice() {
    return this.userInfo.riceNum < 1;
  }
  get machineId() {
    return (this.machineList.filter(
      (item: any) => this.selectAddress === item.position,
    )[0] as any).id;
  }

  @Watch('selectAddress')
  onSelectAddressChange() {
    const temp: any = this.machineList.filter(
      (item: any) => this.selectAddress === item.position,
    )[0];
    machineBalance(temp.id).then((res: any) => {
      this.machineB = res.data;
    });
  }
  async created() {
    // 在微信时登录
    this.bindPhoneVar = this.$route.query.phone ? true : false;
    if (isWeiXin() && !window.localStorage.getItem('unionid')) {
      WechatLogin();
    }

    await this.fetchUserInfo();
    await this.getIfRegister();
    await this.fetchCommonInfo();
    const res = await getList(
      process.env.VUE_APP_ENV_NAME === 'production' ? '4505' : '1',
      1,
    );
    this.newsList = res.data.splice(0, 4);
    this.share();

    window.userInfoChange = () => {
      this.$router.go(0);
    };
  }
  onSelect(action: any) {
    window.location.href = action.url;
  }
  // mounted() {
  //   (this.$refs.img as HTMLImageElement).onload = () => {
  //     setTimeout(() => {
  //       this.show = true;
  //       setTimeout(() => {
  //         this.show1 = true;
  //       }, 4000);
  //     }, 2500);
  //   };
  // }
  copy() {
    Toast('复制成功');
  }
  // 获取用户信息
  async fetchUserInfo() {
    const id = this._getWxId();
    const res: any = await userInfo(id);
    if (res.code === 505) {
      localStorage.removeItem('unionid');
      window.location.reload();
    }
    this.userInfo = res.data;
  }

  // 获取门店、余额相关信息
  async fetchCommonInfo() {
    const res = await balance();
    const machine = await cardMachine();
    const homeInfoRes = await homeInfo();
    const rulesRes = await getRules();
    this.machineList = machine.data;
    this.homeInfo = homeInfoRes.data;
    this.rules = rulesRes.data;
    this.numOfCoffee = res.data;
  }
  // 获取绑定作态
  async getIfRegister() {
    const id = this._getWxId();
    const res: any = await ifRegister(id);
    if (+res.code === 200) {
      this.BIND_PHONE_STATE = false;
    } else if (res.code === 505) {
      localStorage.removeItem('unionid');
      window.location.reload();
    } else {
      this.BIND_PHONE_STATE = true;
    }
  }

  changeRoute(path: string) {
    if (path === './apply') {
      if (!window.udid && !isWeiXin()) {
        this._downloadApp();
        return;
      }
      // 在app的时候
      if (window.gettoken() && window.gettoken() !== 'null') {
        if (!this.BIND_PHONE_STATE) {
          this.bindPhoneVar = true;
          return;
        }
        this.$router.push({
          path: 'apply',
        });
      } else if (isWeiXin()) {
        // 在微信的时候
        if (!window.localStorage.getItem('unionid')) {
          this.$dialog
            .confirm({
              title: '微信登录',
              message: '微信参与活动需要微信登录',
            })
            .then(() => {
              console.log('确定');
              WechatLogin();
            })
            .catch(() => {
              console.log('取消');
            });
        } else if (!this.BIND_PHONE_STATE) {
          // 手机绑定淡出框
          this.bindPhoneVar = true;
        } else {
          this.$router.push({
            path: 'apply',
          });
        }
        console.log('在微信');
      } else {
        if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
      }

      return;
    }
    if (path === './recruit') {
      this.userCenterShow = !this.userCenterShow;
      return;
    }
    this.$router.push({
      path,
    });
  }
  // 兑换优惠券
  handleConvert() {
    console.log('confirm');
    if (this.userInfo.riceNum < 1) {
      return;
    }
    this.confirmConvertVar = true;
  }

  // 确认兑换
  async handleConfirmConvert() {
    if (!this.selectAddress) {
      Toast('请选择兑换地址！');
      return;
    }
    const res: any = await convert(this.machineId, this._getWxId());
    if (res.code === 200) {
      this.confirmConvertVar = false;
      this.successConvertVar = true;
      this.successConvert = res.data;
      this.fetchUserInfo();
    } else {
      Toast(res.msg);
    }
  }
  onConfirm(e: string) {
    this.selectAddress = e;
    this.addressVar = false;
  }
  handleSuccessConvert() {
    this.successConvertVar = false;
  }
  handleRules() {
    this.ruleShow = !this.ruleShow;
  }

  handleUserCenter() {
    this.userCenterShow = !this.userCenterShow;
  }
  changeTab(index: number) {
    this.tabActiveIndex = index;
  }
  async confirmBindPhone() {
    const reg = /^1[3-9][0-9]{9}$/;
    if (reg.test(this.phone)) {
      const data: any = {
        phone: this.phone,
      };
      if (isWeiXin()) {
        data.unionid = this._getWxId();
        data.wxnickname = window.localStorage.getItem('nickname');
        data.wxheadimg = window.localStorage.getItem('headimgurl');
      }
      const res: any = await register(data);
      Toast(res.msg);
      if (+res.code === 200) {
        this.$router.push({
          path: 'apply',
        });
      } else if (res.code === 505) {
        localStorage.removeItem('unionid');
        window.location.reload();
      }
    } else {
      Toast('请输入正确的手机号');
      console.log(this.phone);
    }
  }
  _downloadApp() {
    Dialog.confirm({
      title: '友情提示',
      message: '请在上游新闻App参与活动',
      confirmButtonText: '还没装？一步安装',
      cancelButtonText: '我已安装过',
      closeOnClickOverlay: true,
    })
      .then(() => {
        window.location.href = this.downLoadUrl;
      })
      .catch(() => {
        window.location.href =
          'shangyounews://{"dt":"7","url":"' + document.location.href + '"}';
      });
  }
  _getWxId() {
    let id = '';
    const wxid = window.localStorage.getItem('unionid');
    if (isWeiXin() && wxid) {
      id = wxid as string;
    }
    return id;
  }
  transitionTime(time: string) {
    return moment(+time * 1000).format('YYYY/MM/DD');
  }
  share() {
    this.$appShareInfo({
      title: '光盘有奖 咖啡留香',
      url: location.href,
      subtitle:
        '我正在参与“光盘有奖 咖啡留香”珍惜食物活动，小伙伴们快来给我点赞吧',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '光盘有奖 咖啡留香',
        subtitle:
          '我正在参与“光盘有奖 咖啡留香”珍惜食物活动，小伙伴们快来给我点赞吧',
        link: location.href,
        image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      });
    }
  }
  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }
}
